import { styled } from '@mui/material';
import { SecondaryButton } from 'src/components/Buttons/styles';

export const Button = styled(SecondaryButton)`
    height: 32px;
    font-size: 14px;
    border-radius: 10px;
    padding: 0 12px;
`;